import { useTheme } from '@homebot/shared-ui-swashbuckle'
import classNames from 'classnames'
import styles from './Cluster.module.scss'

export interface ClusterProps {
  id: string
  numberOfPointsInCluster: number
  onClick: (id: string, e: React.MouseEvent<HTMLButtonElement>) => void
}

const Cluster = ({ id, numberOfPointsInCluster, onClick }: ClusterProps) => {
  const label = numberOfPointsInCluster > 9 ? '9+' : numberOfPointsInCluster
  const { theme } = useTheme()
  const isLightThemeType = theme.isLightThemeType
  const isDarkThemeType = !isLightThemeType

  const clusterClassName = classNames(styles.baseCluster, {
    [styles.lightCluster]: isLightThemeType,
    [styles.darkCluster]: isDarkThemeType,
  })

  const labelClassName = classNames(styles.baseLabel, {
    [styles.lightLabel]: isLightThemeType,
    [styles.darkLabel]: isDarkThemeType,
  })

  return (
    <button
      data-cluster-id={id}
      className={clusterClassName}
      onClick={e => onClick(id, e)}
    >
      <svg
        width='12'
        height='13'
        viewBox='0 0 12 13'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M0.923456 1.42345C0.668962 1.42345 0.461731 1.21622 0.461731 0.961725C0.461731 0.707231 0.668962 0.5 0.923456 0.5H11.0778C11.331 0.5 11.5383 0.707231 11.5383 0.961725C11.5383 1.21622 11.331 1.42345 11.0766 1.42345H10.6148V2.3469C11.125 2.3469 11.5383 2.76015 11.5383 3.27035V6.96294C11.5383 7.47314 11.125 7.88639 10.6148 7.88639H4.15432C3.64412 7.88639 3.23087 7.47314 3.23087 6.96294V3.26914C3.23087 2.75894 3.64412 2.34569 4.15432 2.34569V1.42345H2.30742V12.0383C2.30742 12.2928 2.10019 12.5 1.84569 12.5C1.5912 12.5 1.38518 12.2928 1.38518 12.0383V1.42345H0.923456ZM5.07656 2.34569H9.69138V1.42345H5.07656V2.34569Z'
          fill='#DFEDF5'
        />
      </svg>
      <span className={labelClassName}>{label}</span>
    </button>
  )
}

export default Cluster
